
const rolemanagement = resolve =>
  require(["@/components/systemmanagement/rolemanagement/index.vue"], resolve);
const personelManage = resolve =>
  require(["@/components/systemmanagement/personelManage/index.vue"], resolve);
export default [
  
  {
    path: "/homeMain/systemmanagement/rolemanagement",
    component: rolemanagement,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/homeMain/systemmanagement/personelManage",
    component: personelManage,
    meta: {
      keepAlive: true
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/systemmanagement.js